export default
[{
    "project_name": "Trudoo",
    "plot_no": "2.60",
    "client_name": "Costall",
    "client_id": "3",
    "advance_amount": "891114.92",
    "advance_date": "1/12/2018"
  }, {
    "project_name": "Yata",
    "plot_no": "8.94",
    "client_name": "Brawn",
    "client_id": "8",
    "advance_amount": "220478.53",
    "advance_date": "15/5/2018"
  }, {
    "project_name": "Wordpedia",
    "plot_no": "1.43",
    "client_name": "Gomersall",
    "client_id": "524",
    "advance_amount": "616350.01",
    "advance_date": "16/10/2018"
  }, {
    "project_name": "Rhyzio",
    "plot_no": "6.03",
    "client_name": "Bilbrey",
    "client_id": "15",
    "advance_amount": "345161.66",
    "advance_date": "21/12/2018"
  }, {
    "project_name": "DabZ",
    "plot_no": "4.68",
    "client_name": "Thunderchief",
    "client_id": "3219",
    "advance_amount": "122852.01",
    "advance_date": "28/2/2018"
  }, {
    "project_name": "Riffpath",
    "plot_no": "8.70",
    "client_name": "Ortiga",
    "client_id": "1",
    "advance_amount": "816257.94",
    "advance_date": "11/5/2018"
  }, {
    "project_name": "Leexo",
    "plot_no": "7.28",
    "client_name": "Callan",
    "client_id": "0748",
    "advance_amount": "426436.16",
    "advance_date": "16/6/2018"
  }, {
    "project_name": "Talane",
    "plot_no": "0.23",
    "client_name": "Jonke",
    "client_id": "3375",
    "advance_amount": "767826.44",
    "advance_date": "4/5/2018"
  }, {
    "project_name": "Dabvine",
    "plot_no": "9.59",
    "client_name": "Tattershall",
    "client_id": "427",
    "advance_amount": "339862.53",
    "advance_date": "12/2/2018"
  }, {
    "project_name": "Cogilith",
    "plot_no": "5.20",
    "client_name": "Aleshkov",
    "client_id": "50261",
    "advance_amount": "521031.76",
    "advance_date": "11/5/2018"
  }, {
    "project_name": "Mydeo",
    "plot_no": "4.77",
    "client_name": "Staniforth",
    "client_id": "26978",
    "advance_amount": "390061.32",
    "advance_date": "23/1/2018"
  }, {
    "project_name": "Jatri",
    "plot_no": "6.92",
    "client_name": "Minghi",
    "client_id": "27",
    "advance_amount": "664240.81",
    "advance_date": "3/11/2018"
  }, {
    "project_name": "Yombu",
    "plot_no": "4.76",
    "client_name": "Biggerdike",
    "client_id": "8824",
    "advance_amount": "825562.34",
    "advance_date": "11/1/2019"
  }, {
    "project_name": "Cogibox",
    "plot_no": "4.90",
    "client_name": "Dunseath",
    "client_id": "8",
    "advance_amount": "214958.44",
    "advance_date": "3/11/2018"
  }, {
    "project_name": "Quaxo",
    "plot_no": "8.04",
    "client_name": "Conyard",
    "client_id": "4142",
    "advance_amount": "711394.97",
    "advance_date": "21/11/2018"
  }]